import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

/**
 * Phase 4.1 — GrowthAssistant
 * "What should I do next?" — rule-based actionable suggestions.
 */
export const GrowthAssistant = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api.get(`/dashboard/growth-suggestions`)
      .then((r) => { if (!cancelled) setItems(r.data?.suggestions || []); })
      .catch(() => { if (!cancelled) setItems([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  if (loading) {
    return (
      <div className="rounded-2xl border border-purple-500/20 bg-black/30 p-5" data-testid="growth-assistant-loading">
        <div className="h-4 w-44 bg-gray-800 rounded animate-pulse mb-4" />
        {Array.from({ length: 2 }).map((_, i) => (
          <div key={i} className="h-14 bg-gray-800/60 rounded-lg animate-pulse mb-2" />
        ))}
      </div>
    );
  }
  if (!items.length) return null;

  return (
    <div
      className="rounded-2xl border border-fuchsia-500/30 bg-gradient-to-br from-fuchsia-900/15 to-black/40 p-5"
      data-testid="growth-assistant"
    >
      <div className="flex items-center gap-2 mb-3">
        <span className="text-lg">✨</span>
        <h3 className="text-white font-bold text-sm tracking-wide">What should I do next?</h3>
        <span className="text-[10px] px-2 py-0.5 rounded-full bg-fuchsia-500/20 text-fuchsia-200 border border-fuchsia-500/30">Growth</span>
      </div>
      <ul className="space-y-2">
        {items.map((s, i) => (
          <li key={`${s.type}-${i}`}>
            <Link
              to={s.link || "/dashboard"}
              data-testid={`growth-suggestion-${s.type}`}
              className="flex items-center gap-3 p-3 rounded-lg bg-gray-900/40 hover:bg-gray-900/70 border border-gray-800 transition-all"
            >
              <span className="text-2xl shrink-0">{s.emoji}</span>
              <div className="min-w-0 flex-1">
                <p className="text-white font-semibold text-sm">{s.title}</p>
                <p className="text-gray-400 text-xs leading-snug">{s.body}</p>
              </div>
              <span className="text-purple-300 text-xs font-medium shrink-0 hidden sm:block">{s.cta} →</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default GrowthAssistant;
